import { InfiniteData } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { parseAnonymousLearningItem } from '../../models/AnonymousLearningItem'

import * as api from '../api'
import { useLearningItems } from '../entities'
import { useApiInfiniteQuery } from '../useApiInfiniteQuery'
import { learningItemActions } from '../store'
import { ReturnsFavorites, ReturnsLearningItems } from '../useInvalidate'

export default function useFavorites() {
  const dispatch = useDispatch()

  const result = useApiInfiniteQuery({
    queryKey: ['userFavorites', ReturnsLearningItems, ReturnsFavorites],
    placeholderData: (previousData?: InfiniteData<{ uuids: string[]; totalPages: number }, number>) =>
      previousData || {
        pages: [
          {
            uuids: ['dummy-1', 'dummy-2', 'dummy-3', 'dummy-4'],
            totalPages: 1,
          },
        ],
        pageParams: [0],
      },
    queryFn: async (ctx) => {
      const res = await api.get(`course/list-favorites?page=${ctx.pageParam + 1}&page_size=4`)
      const learningItems = parseAnonymousLearningItem.array(res.data)
      dispatch(learningItemActions.add(learningItems))
      return {
        uuids: learningItems.map(({ uuid }) => uuid),
        totalPages: res.lastPage as number,
      }
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages, lastPageParam, _allPageParams) => {
      return lastPageParam + 1 < lastPage.totalPages ? lastPageParam + 1 : null
    },
  })

  const { learningItems } = useLearningItems((result.data?.pages || []).flatMap(({ uuids }) => uuids))

  return {
    fetchNextPage: result.fetchNextPage,
    hasNextPage: result.hasNextPage,
    isFetching: result.isFetching,
    favorites: learningItems,
    result,
  }
}
